/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Create_Project_Name_MaxInputs */



/**
* | output |
* | --- |
* | "Project name must be less than {count} characters" |
*
* @param {Create_Project_Name_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_name_max = /** @type {((inputs: Create_Project_Name_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_Name_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Projektname darf höchstens ${i?.count} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Project name must be less than ${i?.count} characters`)
});